import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.svg';
import { passwordResetRequest } from '../api/client';

function RequestPasswordResetPage() {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setIsSubmitting(true);

    try {
      await passwordResetRequest(email);
      setIsSuccess(true);
    } catch (error) {
      setErrorMessage('Could not process your request. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page page-shell auth-page">
      <div className="public-shell">
        <section className="card public-panel">
          <div className="public-panel-copy">
            <div className="public-brand">
              <img src={logo} alt="Sumrise Logo" />
              <span>Sumrise</span>
            </div>
            <p className="public-kicker">Account recovery</p>
            <h1>Request Password Reset</h1>
            <p>Enter the email address on your account and we&apos;ll send a reset link if that account exists.</p>
          </div>
          <ul className="public-feature-list">
            <li>
              <strong>Privacy-preserving response</strong>
              <p>The confirmation message stays generic and does not reveal whether an email is registered.</p>
            </li>
            <li>
              <strong>Back to sign-in</strong>
              <p>If you remember your password before submitting, you can return directly to login.</p>
            </li>
          </ul>
        </section>

        <section className="card auth-card">
          <div className="auth-card-header">
            <p className="public-kicker">Send reset link</p>
            <p className="muted-text">We&apos;ll email recovery instructions to the address you enter.</p>
          </div>

          {isSuccess ? (
            <div className="notice notice-info">
              If an account exists for that email, we&apos;ve sent a reset link.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="stack-md">
              <div className="stack-xs">
                <label htmlFor="reset-email">Email address</label>
                <input
                  id="reset-email"
                  name="email"
                  type="email"
                  placeholder="name@example.com"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary auth-action" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          {errorMessage ? (
            <div className="notice notice-error">
              {errorMessage}
            </div>
          ) : null}

          <div className="auth-card-footer">
            <p className="muted-text" style={{ fontSize: 'var(--text-sm)' }}>
              Remember your password? <Link to="/login">Sign in</Link>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default RequestPasswordResetPage;
